// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalQRCode_wrapper__YczPR"};